export function isLayerAbleToChangeUnit(layerName) {
  // list of the layers with switchable unit.
  const layersList = ['Wind10M', 'Wind30M', 'Wind50M', 'WindGusts10M', 'WindGusts50M', 'RiskWindSpeed', 'Currents', 'Hurricanes'];
  return layersList.find(name => name === layerName);
}
export function isLayerNotAbleToChangeExtreme(layerName) {
  const layersList = ['WaterLevelLat', 'WaterLevelHat'];
  return !layersList.find(name => name === layerName);
}
export const updateURLWithParameters = (url, layerName, layer) => {
  const isUnitChangeable = isLayerAbleToChangeUnit(layerName);
  const isExtremeValueChangeable = isLayerNotAbleToChangeExtreme(layerName);
  let newUrl = `${url}`;
  const hasParameters = url.indexOf('?') > -1;

  if (isUnitChangeable && layer && layer.unit) {
    newUrl = hasParameters ? `${newUrl}&unit={unit}` : `${url}?unit={unit}`;
  }

  if (isExtremeValueChangeable && layer && Object(layer).hasOwnProperty('plot_extrema')) {
    newUrl = hasParameters ? `${newUrl}&plot_extrema={plot_extrema}` : `${url}?plot_extrema={plot_extrema}`;
  }

  return newUrl;
};
export function getUnitFactor(unit) {
  return unit === 'KTS' ? 1 : 1.943844;
}